import { render, staticRenderFns } from "./FlatDocumentsModal.vue?vue&type=template&id=594e3cf2&lang=pug&"
import script from "./FlatDocumentsModal.vue?vue&type=script&lang=ts&"
export * from "./FlatDocumentsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports